import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "../../../environments/environment";
import { CloudinaryTransformPipe } from "./cloudinary-transform.pipe";


@Pipe({name: "cloudinaryImageTransform"})
export class CloudinaryImageTransformPipe extends CloudinaryTransformPipe implements PipeTransform {

  type: "video" | "image" = "image";

}